export default "__VITE_ASSET__KdkRebvFRkxOg6AMh2RxHg__"